import { DestroyRef, Injectable, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MatDateFormats,
} from "@angular/material/core";
import { TranslateService } from "@ngx-translate/core";
import { resolveAngularLocale } from "../helpers/locale.helper";
import { buildMaterialDateFormats } from "../helpers/material-date-formats.helper";

/**
 * Keeps Angular Material datepickers aligned with the active ngx-translate language.
 */
@Injectable({ providedIn: "root" })
export class MaterialDateLocaleService {
  private readonly translate = inject(TranslateService);
  private readonly dateAdapter = inject<DateAdapter<unknown>>(DateAdapter);
  private readonly dateFormats = inject<MatDateFormats>(MAT_DATE_FORMATS);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.applyLocale(
      this.translate.currentLang || this.translate.defaultLang || "en",
    );

    this.translate.onLangChange
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((event) => this.applyLocale(event.lang));
  }

  private applyLocale(lang: string): void {
    const locale = resolveAngularLocale(lang);
    this.dateAdapter.setLocale(locale);
    Object.assign(this.dateFormats, buildMaterialDateFormats(lang));
  }
}
